import { jwtDecode } from "jwt-decode";

interface JwtClaims {
  userId: number | null;
  role: string | null;
  tenantId: number | null;
  mustChangePassword?: boolean;
  iat?: number;
  exp?: number;
}

export const decodeToken = (token: string): JwtClaims | null => {
  try {
    return jwtDecode<JwtClaims>(token);
  } catch {
    return null;
  }
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const decoded = jwtDecode<JwtClaims>(token);
    if (!decoded.exp) return true;
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const getTokenClaims = (token: string): JwtClaims | null => {
  const decoded = decodeToken(token);
  if (!decoded) return null;
  return {
    userId: decoded.userId ?? null,
    role: decoded.role ?? null,
    tenantId: decoded.tenantId ?? null,
    mustChangePassword: decoded.mustChangePassword === true,
    iat: decoded.iat,
    exp: decoded.exp,
  };
};
